export class User {
  id: number;
  enable_invoice_notifications: boolean;

  constructor(id: number) {
    this.id = id;
    this.enable_invoice_notifications = false;
  }

  toggleAndSaveInvoiceNotification(value: boolean) {
    this.enable_invoice_notifications = value;
  }
}
